module.exports = __webpack_public_path__ + "bbbfbeaef5b6914828fd03dadb13621f.png";